//处理token保存时长
export function setCookieWithDuration(expiresInSeconds) {
  // 获取当前时间
  let currentDate = new Date();
  // 计算过期时间
  let expirationDate = new Date(
    currentDate.getTime() + expiresInSeconds * 1000
  );
  return expirationDate;
}
//获取ua机型
const ua = navigator.userAgent || navigator.vendor || window.opera;
const bIsApp = ua.toLocaleLowerCase().indexOf('wen jing ke tang') >= 0; // 根据app的关键字判断是否为app中
const bIsIpad = /ipad/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); // iOS13 以后的 iPad，navigator.platform 返回"MacIntel"，相当于 Mac，由于目前还没有触摸屏的 Mac，所以可以通过最大触控点来区分 Mac 和 iPad 的。
const bIsIpod = /iPod/i.test(ua);
const bIsIphoneOs = /iphone/i.test(ua);
const bIsMidp = /midp/i.test(ua);
const bIsUc7 = /rv:1.2.3.4/i.test(ua);
const bIsUc = /ucweb/i.test(ua);
const bIsAndroid = /android/i.test(ua);
const bIsCE = /windows ce/i.test(ua);
const bIsWM = /windows mobile/i.test(ua);
const bIsWechat = /MicroMessenger/i.test(ua);
const bIsIPhoneX = /iphone/gi.test(ua) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 375 && window.screen.height === 812;
const bIsIPhoneXSMax = /iphone/gi.test(ua) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 414 && window.screen.height === 896;
const bIsIPhoneXR = /iphone/gi.test(ua) && window.devicePixelRatio && window.devicePixelRatio === 2 && window.screen.width === 414 && window.screen.height === 896;
export const device = {
  isWechat: bIsWechat,
  isApp: bIsApp,
  isMobile: bIsIpad || bIsIpod || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM || bIsWechat,
  isIos: bIsIpad || bIsIpod || bIsIphoneOs,

  isIPhoneX: bIsIPhoneX || bIsIPhoneXSMax || bIsIPhoneXR
}
